// extracted by mini-css-extract-plugin
module.exports = {"toTop":"ToTop_toTop__-8JqM","mobile":"ToTop_mobile__q7Sb3"};